/* @flow */
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'payments/reducers/activityRecipients';
import Activity from 'entities/Activity';
import ActivityResponsesTable from 'payments/components/ActivityResponsesTable.jsx';
import React, { Component, PropTypes } from 'react';
import RecipientsNux from 'payments/components/RecipientsNux.jsx';
import WalletTabLoader from 'payments/components/WalletTabLoader.jsx';
import ActivityRecipients from 'collections/ActivityRecipients';

type Props = {
  activity: Activity,
  loading?: boolean,
  recipients?: ?ActivityRecipients,
  // FIXME react-redux not merging this by mapDispatchToProps
  loadActivityRecipients?: (activityId: number) => void,
};

class ActivityResponsesTableContainer extends Component {
  props: Props;

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  static defaultProps = {
    loading: false,
  };

  componentWillMount() {
    // force update on each mount.
    if (this.props.loadActivityRecipients) {
      this.props.loadActivityRecipients(this.props.activity.id);
    }
  }

  render() {
    const alreadyLoaded = !!this.props.recipients;
    if ((this.props.loading && !alreadyLoaded) || !this.props.recipients) {
      return <WalletTabLoader />;
    }

    if (this.props.recipients.length === 0) {
      return <RecipientsNux activity={this.props.activity} />;
    }

    const sort = this.context.router.location.query.sort;

    return (
      <ActivityResponsesTable
        activity={this.props.activity}
        recipients={this.props.recipients}
        initialSort={sort}
      />
    );
  }
}

function mapStateToProps(state: Object, props: Object) {
  const activity = state.activityRecipients.activities[props.activity.id] || {};
  return {
    loading: activity.loadingRecipients,
    recipients: activity.recipients,
  };
}

const mapDispatchToProps = (dispatch: Function) =>
  // $FlowIssue
  bindActionCreators({
    loadActivityRecipients: actions.loadActivityRecipients,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ActivityResponsesTableContainer);



// WEBPACK FOOTER //
// ./src/payments/containers/ActivityResponsesTableContainer.jsx